export default "__VITE_ASSET__DhIMaDdN__"